import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { Box, Button, Card, Typography, makeStyles } from '@material-ui/core'

import UseAnalytics from '~/analytics/hooks/useAnalytics'
import CheckoutList from '~/checkout/components/CheckoutList/CheckoutList'
import { selectContractId } from '~/checkout/store/checkout.selectors'
import VerticalLinearStepper from '~/legal/components/NextStepsTexts/NextStepsTexts'
import SalesConsents from '~/legal/components/SalesConsents/SalesConsents'
import useResetSale from '~/sale/hooks/useResetSale'
import { selectTheme } from '~/ui/theme/store/theme.selectors'

const useStyles = makeStyles({
  brand: {
    textTransform: 'capitalize',
  },
})

export default function CheckoutPage() {
  const contractId = useSelector(selectContractId)
  const { resetSale } = useResetSale()
  const brand = useSelector(selectTheme)
  const { purchase } = UseAnalytics()

  const classes = useStyles()

  useEffect(() => {
    if (contractId) {
      purchase(contractId)
    }
  }, [contractId])
  return (
    <div data-hook="checkout-page">
      <CheckoutList />

      {contractId ? (
        <>
          <SalesConsents />
          <Box mt={6}>
            <VerticalLinearStepper />
          </Box>
          <Box mt={6}>
            <Card elevation={5}>
              <Box p={5}>
                <Typography variant="body1">
                  Ya está. En este momento comenzamos la gestión de tu pedido. Si para finalizarlo
                  fuera necesario solicitar documentación, nos pondremos en contacto contigo.
                  Bienvenido a <span className={classes.brand}>{brand}</span>. ¡Que pases un buen
                  día!
                </Typography>
              </Box>
            </Card>
          </Box>
        </>
      ) : null}
      <Box mt={6}>
        <Button
          data-hook="back-to-start-btn"
          variant="contained"
          color="secondary"
          onClick={() => resetSale(brand)}
        >
          Volver a pantalla de inicio
        </Button>
      </Box>
    </div>
  )
}
